// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/integration.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateIntegrationDefinitionRequest, CreateIntegrationDefinitionResponse, CreateIntegrationRequest, CreateIntegrationResponse, DeleteIntegrationDefinitionRequest, DeleteIntegrationDefinitionResponse, DeleteIntegrationRequest, DeleteIntegrationResponse, GetIntegrationDefinitionRequest, GetIntegrationDefinitionResponse, GetIntegrationRequest, GetIntegrationResponse, ListIntegrationDefinitionsRequest, ListIntegrationDefinitionsResponse, ListIntegrationsRequest, ListIntegrationsResponse, UpdateIntegrationDefinitionRequest, UpdateIntegrationDefinitionResponse, UpdateIntegrationRequest, UpdateIntegrationResponse, ValidateIntegrationRequest, ValidateIntegrationResponse } from "./integration_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.IntegrationService
 */
export const IntegrationService = {
  typeName: "gitpod.v1.IntegrationService",
  methods: {
    /**
     * Lists available integration definitions.
     *
     * Use this method to:
     * - View all available integrations
     * - Check integration capabilities
     * - Discover supported services
     *
     *
     * @generated from rpc gitpod.v1.IntegrationService.ListIntegrationDefinitions
     */
    listIntegrationDefinitions: {
      name: "ListIntegrationDefinitions",
      I: ListIntegrationDefinitionsRequest,
      O: ListIntegrationDefinitionsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Creates a new integration definition.
     * Requires service account authentication.
     *
     * Use this method to:
     * - Add new integration types dynamically
     * - Configure integration capabilities
     * - Set up authentication requirements
     *
     *
     * @generated from rpc gitpod.v1.IntegrationService.CreateIntegrationDefinition
     */
    createIntegrationDefinition: {
      name: "CreateIntegrationDefinition",
      I: CreateIntegrationDefinitionRequest,
      O: CreateIntegrationDefinitionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific integration definition.
     *
     * Use this method to:
     * - View integration definition configuration
     * - Check supported capabilities
     * - Verify authentication requirements
     *
     *
     * @generated from rpc gitpod.v1.IntegrationService.GetIntegrationDefinition
     */
    getIntegrationDefinition: {
      name: "GetIntegrationDefinition",
      I: GetIntegrationDefinitionRequest,
      O: GetIntegrationDefinitionResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates an existing integration definition.
     * Requires service account authentication.
     *
     * Use this method to:
     * - Modify integration capabilities
     * - Update authentication configuration
     * - Change integration metadata
     *
     *
     * @generated from rpc gitpod.v1.IntegrationService.UpdateIntegrationDefinition
     */
    updateIntegrationDefinition: {
      name: "UpdateIntegrationDefinition",
      I: UpdateIntegrationDefinitionRequest,
      O: UpdateIntegrationDefinitionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes an integration definition.
     * Requires service account authentication.
     * Fails if any integrations depend on this definition.
     *
     * Use this method to:
     * - Remove unused integration types
     * - Clean up deprecated integrations
     *
     *
     * @generated from rpc gitpod.v1.IntegrationService.DeleteIntegrationDefinition
     */
    deleteIntegrationDefinition: {
      name: "DeleteIntegrationDefinition",
      I: DeleteIntegrationDefinitionRequest,
      O: DeleteIntegrationDefinitionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a new integration instance within an organization.
     *
     * Use this method to:
     * - Instantiate an integration for an organization
     * - Configure integration-specific settings
     * - Enable integration capabilities
     *
     *
     * @generated from rpc gitpod.v1.IntegrationService.CreateIntegration
     */
    createIntegration: {
      name: "CreateIntegration",
      I: CreateIntegrationRequest,
      O: CreateIntegrationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific integration instance.
     *
     * Use this method to:
     * - View integration configuration
     * - Check integration status
     * - Verify enabled capabilities
     *
     *
     * @generated from rpc gitpod.v1.IntegrationService.GetIntegration
     */
    getIntegration: {
      name: "GetIntegration",
      I: GetIntegrationRequest,
      O: GetIntegrationResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates an existing integration instance.
     *
     * Use this method to:
     * - Modify integration settings
     * - Enable/disable capabilities
     * - Change integration status
     *
     *
     * @generated from rpc gitpod.v1.IntegrationService.UpdateIntegration
     */
    updateIntegration: {
      name: "UpdateIntegration",
      I: UpdateIntegrationRequest,
      O: UpdateIntegrationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes an integration instance.
     *
     * Use this method to:
     * - Remove unused integrations
     * - Clean up configurations
     * - Revoke integration access
     *
     *
     * @generated from rpc gitpod.v1.IntegrationService.DeleteIntegration
     */
    deleteIntegration: {
      name: "DeleteIntegration",
      I: DeleteIntegrationRequest,
      O: DeleteIntegrationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists integration instances for the organization.
     *
     * Use this method to:
     * - View all integrations for an organization
     * - Monitor integration configurations
     *
     *
     * @generated from rpc gitpod.v1.IntegrationService.ListIntegrations
     */
    listIntegrations: {
      name: "ListIntegrations",
      I: ListIntegrationsRequest,
      O: ListIntegrationsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Validates an integration's configuration and connectivity.
     *
     * Runs a set of checks (e.g. app token validity) and returns results for each.
     * All checks are always returned; failing checks include a message and an optional action_hint.
     *
     *
     * @generated from rpc gitpod.v1.IntegrationService.ValidateIntegration
     */
    validateIntegration: {
      name: "ValidateIntegration",
      I: ValidateIntegrationRequest,
      O: ValidateIntegrationResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

